export const REGISTER_TO_ATTEND_URL = 'https://zfrmz.in/NFxlfeqRLlFCLuLYXBLA';
export const EVENT_DATE_LABEL = '8th October 2026';
export const EVENT_VENUE_LABEL = 'Aerocity, New Delhi';

export const CEREMONY_LINKS = [
  {
    to: '/winners',
    label: 'Winners',
    note: 'Winners announced on 8th October',
    liveNote: 'Winners announced · View the honour roll',
    desc: 'The complete honour roll across every AdAura pillar and category will be published here right after the ceremony.',
    liveDesc: 'The complete honour roll — Gold, Silver and Bronze across every AdAura pillar and category — is now live.',
  },
  {
    to: '/gallery',
    label: 'Photo Gallery',
    note: 'Live from 8th October',
    desc: 'Moments from the red carpet, the stage and the room — captured live on awards night and updated through the evening.',
  },
];
